var _rect, _g, _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAbsenceRequest = function SvgAbsenceRequest(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13880_35864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.7391,
    height: 21.7391,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13880_35864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.61537 18.6958C4.17612 18.6958 3.80433 18.5436 3.49998 18.2392C3.19563 17.9349 3.04346 17.5631 3.04346 17.1238V5.4851C3.04346 5.04585 3.19563 4.67406 3.49998 4.36971C3.80433 4.06536 4.17612 3.91319 4.61537 3.91319H5.81939V2.7426C5.81939 2.55198 5.88322 2.39284 6.01087 2.26519C6.13851 2.13755 6.29765 2.07373 6.48828 2.07373C6.67891 2.07373 6.83804 2.13755 6.9657 2.26519C7.09333 2.39284 7.15715 2.55198 7.15715 2.7426V3.91319H13.7458V2.72588C13.7458 2.54083 13.8082 2.38587 13.933 2.26101C14.0579 2.13616 14.2129 2.07373 14.3979 2.07373C14.583 2.07373 14.7379 2.13616 14.8628 2.26101C14.9877 2.38587 15.0501 2.54083 15.0501 2.72588V3.91319H16.2541C16.6934 3.91319 17.0652 4.06536 17.3695 4.36971C17.6739 4.67406 17.826 5.04585 17.826 5.4851V17.1238C17.826 17.5631 17.6739 17.9349 17.3695 18.2392C17.0652 18.5436 16.6934 18.6958 16.2541 18.6958H4.61537ZM4.61537 17.3914H16.2541C16.321 17.3914 16.3823 17.3636 16.4381 17.3078C16.4938 17.2521 16.5217 17.1907 16.5217 17.1238V8.96336H4.34778V17.1238C4.34778 17.1907 4.37565 17.2521 4.43139 17.3078C4.48715 17.3636 4.54847 17.3914 4.61537 17.3914ZM10.4347 12.2409C10.2218 12.2409 10.0404 12.166 9.89044 12.016C9.74049 11.8661 9.66552 11.6846 9.66552 11.4717C9.66552 11.2588 9.74049 11.0773 9.89044 10.9274C10.0404 10.7775 10.2218 10.7025 10.4347 10.7025C10.6477 10.7025 10.8291 10.7775 10.979 10.9274C11.129 11.0773 11.204 11.2588 11.204 11.4717C11.204 11.6846 11.129 11.8661 10.979 12.016C10.8291 12.166 10.6477 12.2409 10.4347 12.2409ZM6.95648 12.2409C6.74355 12.2409 6.56212 12.166 6.41217 12.016C6.26223 11.8661 6.18726 11.6846 6.18726 11.4717C6.18726 11.2588 6.26223 11.0773 6.41217 10.9274C6.56212 10.7775 6.74355 10.7025 6.95648 10.7025C7.16941 10.7025 7.35084 10.7775 7.50078 10.9274C7.65073 11.0773 7.7257 11.2588 7.7257 11.4717C7.7257 11.6846 7.65073 11.8661 7.50078 12.016C7.35084 12.166 7.16941 12.2409 6.95648 12.2409ZM13.913 12.2409C13.7001 12.2409 13.5186 12.166 13.3687 12.016C13.2188 11.8661 13.1438 11.6846 13.1438 11.4717C13.1438 11.2588 13.2188 11.0773 13.3687 10.9274C13.5186 10.7775 13.7001 10.7025 13.913 10.7025C14.1259 10.7025 14.3074 10.7775 14.4573 10.9274C14.6072 11.0773 14.6822 11.2588 14.6822 11.4717C14.6822 11.6846 14.6072 11.8661 14.4573 12.016C14.3074 12.166 14.1259 12.2409 13.913 12.2409ZM10.4347 15.6523C10.2218 15.6523 10.0404 15.5773 9.89044 15.4274C9.74049 15.2774 9.66552 15.096 9.66552 14.8831C9.66552 14.6702 9.74049 14.4887 9.89044 14.3388C10.0404 14.1888 10.2218 14.1138 10.4347 14.1138C10.6477 14.1138 10.8291 14.1888 10.979 14.3388C11.129 14.4887 11.204 14.6702 11.204 14.8831C11.204 15.096 11.129 15.2774 10.979 15.4274C10.8291 15.5773 10.6477 15.6523 10.4347 15.6523ZM6.95648 15.6523C6.74355 15.6523 6.56212 15.5773 6.41217 15.4274C6.26223 15.2774 6.18726 15.096 6.18726 14.8831C6.18726 14.6702 6.26223 14.4887 6.41217 14.3388C6.56212 14.1888 6.74355 14.1138 6.95648 14.1138C7.16941 14.1138 7.35084 14.1888 7.50078 14.3388C7.65073 14.4887 7.7257 14.6702 7.7257 14.8831C7.7257 15.096 7.65073 15.2774 7.50078 15.4274C7.35084 15.5773 7.16941 15.6523 6.95648 15.6523ZM13.913 15.6523C13.7001 15.6523 13.5186 15.5773 13.3687 15.4274C13.2188 15.2774 13.1438 15.096 13.1438 14.8831C13.1438 14.6702 13.2188 14.4887 13.3687 14.3388C13.5186 14.1888 13.7001 14.1138 13.913 14.1138C14.1259 14.1138 14.3074 14.1888 14.4573 14.3388C14.6072 14.4887 14.6822 14.6702 14.6822 14.8831C14.6822 15.096 14.6072 15.2774 14.4573 15.4274C14.3074 15.5773 14.1259 15.6523 13.913 15.6523Z",
    fill: "url(#paint0_linear_13880_35864)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4783,
    cy: 18.4783,
    r: 6.52174,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7391 21.913C20.0443 21.913 21.913 20.0443 21.913 17.7391C21.913 15.4339 20.0443 13.5652 17.7391 13.5652C15.4339 13.5652 13.5652 15.4339 13.5652 17.7391C13.5652 20.0443 15.4339 21.913 17.7391 21.913Z",
    stroke: "url(#paint1_linear_13880_35864)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5247 16.4873C16.6228 16.2083 16.8165 15.9731 17.0714 15.8233C17.3264 15.6734 17.6261 15.6187 17.9176 15.6687C18.209 15.7187 18.4734 15.8702 18.6638 16.0964C18.8543 16.3226 18.9585 16.609 18.958 16.9047C18.958 17.7395 17.7059 18.1569 17.7059 18.1569",
    stroke: "url(#paint2_linear_13880_35864)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.739 19.8262H17.743",
    stroke: "url(#paint3_linear_13880_35864)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13880_35864",
    x1: 10.4347,
    y1: 2.07373,
    x2: 10.4347,
    y2: 18.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13880_35864",
    x1: 17.7391,
    y1: 13.5652,
    x2: 17.7391,
    y2: 21.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13880_35864",
    x1: 17.7414,
    y1: 15.6506,
    x2: 17.7414,
    y2: 18.1569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13880_35864",
    x1: 17.741,
    y1: 19.8262,
    x2: 17.741,
    y2: 20.8262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564FE8"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAbsenceRequest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "absence-request.7d5d7acdbb189030d829f2e23c63a3bf.svg";